class Timer {
  constructor(delay, callback, loopCount = 1) {
    this.callback = callback
    this.delay = delay
    this.loopTotal = loopCount
    this.loopCount = 0
    this.remaining = delay
    this.startTime = null
    this.timerId = null
    this.paused = true
  }

  callCallback = () => {
    this.loopCount += 1
    this.callback(this.loopCount)
    this.pause()
    if (this.canContinue()) {
      this.remaining = this.delay
      this.resume()
    } else {
      this.remaining = 0
    }
  }

  canContinue = () => this.loopTotal === 0 || this.loopCount < this.loopTotal

  getRemainingTime = () => (this.paused ? this.remaining : new Date() - this.startTime)

  pause = () => {
    if (!this.paused) {
      clearTimeout(this.timerId)
      this.remaining = Math.max(this.remaining - this.getRemainingTime(), 1)
      this.paused = true
      return true
    }
    return false
  }

  resume = () => {
    if (this.paused && this.remaining > 0 && this.canContinue()) {
      this.startTime = new Date()
      this.paused = false
      this.timerId = setTimeout(this.callCallback, this.remaining)
      return true
    }
    return false
  }

  start = this.resume

  stop = () => {
    if (this.pause()) {
      this.startTime = null
      this.loopCount += 1
      this.remaining = this.canContinue() ? this.delay : 0
      return true
    }
    return false
  }
}

export default Timer
